/**
 * This is the tag for Status update event
 * @type {string}
 */
export const UPDATE_STATUS_EVENT_TAG = "STATUS_UPDATE"

/**
 * This is the tag for Post loading status update event
 * @type {string}
 */
export const UPDATE_STATUS_POST_LOAD_TAG = "POST_LOADING_STATUS"

/**
 * This is the tag for Post id fetch update event
 * @type {string}
 */
export const UPDATE_POST_ID_FETCH_TAG = "FETCHING_POST_ID"
